import NoData from '@/components/common/NoData'
import FooterSetup from '@/features/design-system/components/common/FooterSetup'
import { DATA_PAGINATION } from '@/types'
import { FertigationSetup } from '@/types/fertigation'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'
import useTranslation from '@/hooks/useTranslation'

interface FertigationTableProps {
  data?: DATA_PAGINATION<FertigationSetup>
}

const FertigationTable: FC<FertigationTableProps> = ({ data }) => {
  const { t } = useTranslation()
  
  return (
    <Stack flexGrow="1" justifyContent="space-between" height="100%">
      {data && data.data.length > 0 && (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    width: '29px',
                    position: 'sticky',
                    left: 0,
                  }}
                >
                  #
                </TableCell>
                <TableCell
                  sx={{
                    width: '182px',
                    position: 'sticky',
                    left: 0,
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    width: '562.5px',
                  }}
                >
                  Capacity
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row.id}
                  </TableCell>
                  <TableCell>{row?.name}</TableCell>
                  <TableCell>{row?.capacity}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {data && data.data.length === 0 && <NoData text={ t('noData') } />}

      <Stack>
        <FooterSetup
          title={`${data?.totalCount || 0} rows of data detected`}
          subtitle="Review the data before proceeding"
        />
      </Stack>
    </Stack>
  )
}

export default FertigationTable
